import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  editUnitRelation: {
    data: {},
    isEditMode: false,
  },
};
const unitRelationSlice = createSlice({
  name: "unitRelation",
  initialState,
  reducers: {
    setIsEditMode: (state, action) => {
      state.editUnitRelation = action.payload;
    },
    clearEditUnitRelation: (state) => {
      state.editUnitRelation = {
        data: {},
        isEditMode: false,
      };
    },
  },
});

export const { setIsEditMode, clearEditUnitRelation } =
  unitRelationSlice.actions;
export default unitRelationSlice.reducer;
